import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <img
                src="https://public.readdy.ai/ai/img_res/3e9658ac-729b-4655-aa27-3366e7307ffc.png"
                alt="Logo"
                className="h-12 w-auto object-contain"
              />
            </Link>
            {/* Mobile phone number */}
            <a
              href="tel:8327839969"
              className={`md:hidden text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Call or Text 832.783.9969
            </a>
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('listings')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                }`}
              >
                Properties
              </button>
              <button
                onClick={() => scrollToSection('amenities')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                }`}
              >
                Amenities
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                }`}
              >
                Reviews
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                }`}
              >
                Contact
              </button>
              <a
                href="tel:8327839969"
                className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Call or Text - 832.783.9969
              </a>
              <a
                href="https://71910_1.holidayfuture.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-rose-500 text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Sticky mobile bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-white/95 backdrop-blur-sm border-t border-gray-100 shadow-lg">
        <div className="flex items-center gap-3">
          <a
            href="tel:8327839969"
            className="flex items-center justify-center space-x-2 flex-1 bg-teal-500 text-white py-3 rounded-full text-sm font-semibold hover:bg-teal-600 active:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base"></i>
            </div>
            <span>Call / Text</span>
          </a>
          <a
            href="https://71910_1.holidayfuture.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center space-x-2 flex-1 bg-rose-500 text-white py-3 rounded-full text-sm font-semibold hover:bg-rose-600 active:bg-rose-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-base"></i>
            </div>
            <span>Book Now</span>
          </a>
        </div>
      </div>
    </>
  );
}